// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import components
import {NestableItem} from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {deleteItem} from "../../utils/helperFunctions";
import {
    GetVacancies,
    DeleteVacancyById,
    UpdateVacanciesPositions
} from "../../redux/actions";


class Vacancy extends Component {
    constructor(props) {
        super(props);
        this.deleteVacancy = deleteItem.bind(this, props.DeleteVacancyById, 'հաստիքը');
        // this.onPositionChange = this.onPositionChange.bind(this);
    }

    componentDidMount() {
        this.props.GetVacancies();
    }

    getNestableItems(list = null) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {

            items.push({
                id: item.id,
                index: index,
                title: item.title,
                withImage: false,
                isHidden: item.isHidden,
                path: item?.image_url,
                link: {
                    pathname: `vacancy/edit/${item.id}`,
                },
                deleteCb: () => this.deleteVacancy(item.id),
                children: []
            })
        });
        return items;
    }

    // async onPositionChange(items, item) {
    //     const movedVacancyId = item.id;
    //     const {vacancyList} = this.props;
    //     // const positionedItems = items.map((item, index) => {
    //     //     return {id: item.id, position: index}
    //     // });
    //     // if (~vacancyList.findIndex(m => m.id === movedVacancyId) &&
    //     //     ~positionedItems.findIndex(m => m.id === movedVacancyId)) {
    //     //     // first level menu was re-positioned in first level
    //     //     // await this.props.UpdateVacanciesPositions(positionedItems);
    //     //     this.props.GetVacancies();
    //     // }
    // }

    render() {
        let {vacancyList} = this.props;
        let items = this.getNestableItems(vacancyList);
        return <PageWrapper pageTitle={'Թափուր Հաստիքներ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/vacancy/add"}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                handler={()=>{}}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetVacancies,
    DeleteVacancyById,
    UpdateVacanciesPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(Vacancy);
